@if (statisticService.isLoading()) {
    <app-loading class="h-full" />
} @else {
    <div class="flex flex-wrap justify-between items-stretch m-auto w-full h-fit">
        @for (computedStatistic of statisticService.computedStatisticList(); track computedStatistic.id) {
            <app-chart
                class="flex-grow h-full"
                [class]="statisticService.getClassByRenderType(computedStatistic)"
                [computedStatistic]="computedStatistic"
                [isExpanded]="!statisticService.isMapExpanded()"
                [showLabels]="isPrintScreen()"
                (ready)="updatePendingCharts(computedStatistic.id)" />
        } @empty {
            <div class="flex justify-center items-center m-auto w-full h-fit">
                <app-no-data-to-display
                    iconSize="5x"
                    information="noDataFound" />
            </div>
        }
    </div>
}
